export default "__VITE_ASSET__da116bb4__"